import React from 'react';
import { Section } from './ui/Section';
import { MessageCircle } from 'lucide-react';
export function SocialProof() {
  return <Section className="bg-brand-beige" data-id="element-212">
      <div className="text-center mb-10" data-id="element-213">
        <h2 className="text-2xl md:text-3xl font-bold text-gray-900" data-id="element-214">
          Lo que vas a empezar a escuchar
        </h2>
        <p className="text-gray-600 mt-2" data-id="element-215">(cuando lo publiques)</p>
      </div>

      <div className="grid md:grid-cols-3 gap-6 max-w-5xl mx-auto" data-id="element-216">
        {['“¿Me lo mandas? Lo necesito.”', '“¿Cuánto cuesta? ¿Cómo lo compro?”', '“Por fin algo que sí entiendo y sí puedo hacer.”'].map((quote, i) => <div key={i} className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 relative" data-id="element-217">
            <MessageCircle className="w-8 h-8 text-brand-pink/20 absolute top-4 right-4" data-id="element-218" />
            <p className="text-gray-800 font-medium italic text-lg" data-id="element-219">{quote}</p>
          </div>)}
      </div>
    </Section>;
}